import jquery from 'jquery';

import JF from '../../assets/js/Utility/JqueryFunctions.js';

jquery.fn.inViewport    = JF.inViewport;
jquery.fn.isTablet      = JF.isTablet;
jquery.fn.isMobile      = JF.isMobile;

window.jQuery = jquery;
window.$ = jquery;

// https://github.com/stefanpenner/es6-promise
require('es6-promise').polyfill();

import axios from 'axios';
window.axios = axios;

import Vue from 'vue';
Vue.prototype.$http = axios;
window.Vue = Vue;

import JqueryTools from '../../assets/js/Libs/JqueryTools.js';
JqueryTools();

import ViewportSize from '../../assets/3rd_party/viewportSize/viewportSize-min.js';
ViewportSize();

import FlexSlider from '../../assets/3rd_party/flexslider/2.7.2/jquery.flexslider.js';
FlexSlider();

import ev_widgets from '../../assets/top/rcmg_users_v2/evolok/ev-widgets/3.5.18/ev-widgets.min.js'; 
import EvLib from '../../assets/js/Libs/EvolokLibrary.js';
EvLib();
// import ev_widgets from '../../assets/top/rcmg_users_v2/evolok/ev-widgets/3.5.18/ev-widgets.min.js';

// Picture element HTML5 shiv
document.createElement("picture");
import 'picturefill';

import ModernizerWebp from '../../assets/js/Libs/Modernizr-Webp.js';
ModernizerWebp();

import MbidIframeInsert from '../../assets/js/Utility/MbidIframeInsert.js';
MbidIframeInsert();

import GaAnalytics from '../../assets/js/Analytics/GaAnalytics.js'
GaAnalytics();